import Axios from '@/axios';

// 预约来访人员列表查询
export const getReservedVisitor = data => {
  return Axios({
    url: '/face/web/appointment/index_appointment_visitor',
    method: 'POST',
    type: 'json',
    data
  })
}
// 预约申请详情
export const getReservedDetail = params => {
  return Axios({
    url: '/face/web/appointment/show_appointment_apply/' + params.id,
    method: 'GET',
    type: 'json',
    params
  })
}
// 预约申请详情
export const exportReservedList = params => {
  return Axios({
    url: '/face/web/appointment/export_appointment_visitor',
    method: 'POST',
    type: 'json',
    params
  })
}
// 用户导入预约申请
export const importAppointmentApply = data => {
  return Axios({
    url: '/face/web/appointment/import_appointment_apply',
    method: 'POST',
    type: 'json',
    data
  })
}
// 审核预约申请
export const approvalApply = data => {
  return Axios({
    url: '/face/web/appointment/user_approval_appointment_apply',
    method: 'POST',
    type: 'json',
    data
  })
}
